import { connect } from "react-redux";

import { providePopulateData } from "components/utility/hoc/PopulateData";

var CurrentUser = require("lib/account/CurrentUser");
var TextTypes = require("lib/academic/TextTypes");

var PaginationControls = require("components/utility/PaginationControls");
var BookDisplay = require("components/reading/books/BookDisplay");

var ButtonDropdown = require("components/utility/ButtonDropdown");
var ButtonDropdownOption = require("components/utility/ButtonDropdownOption");
var LoadingButton = require("components/utility/LoadingButton");

var ReadingActions = require("lib/actions/ReadingActions");

require("reading/picks/add_manual_url_pick.scss");

@connect(
	(state, props) => ({}),
	(dispatch, props) => ({
		createBook: (book) => {
			return dispatch(ReadingActions.createBook({ book }));
		}
	}),
)
class AddManualURLPick extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = this.getInitialState();
	}

	getInitialState() {
		return {
			url: "", title: "",
			textVariety: TextTypes.Varieties.FICTION,
			loading: false
		}
	}

	addText(book) {
		window.wrNotifications.triggerDropDownNotification({
			title: "Added URL!", text: "You have added a URL for your students.", icon: "ok-sign"
		});

		this.props.toggleAssign(book);
	}

	isValid() {
		return this.state.url.trim().length && this.state.title.trim().length;
	}

	onSubmit(e) {
		$wr.nope(e);

		if (!this.isValid()) {
			return
		}

		var book = {
			url: this.state.url,
			title: this.state.title,
			as_admin: true,
			text_variety: this.state.textVariety
		}

		this.setState({ loading: true });
		this.props.createBook(book).then((response) => {
			this.addText(response.books[0]);

			this.setState(this.getInitialState())
		})
	}

	render() {
		return (
			<div className="addManualURLPick">
				<form onSubmit={ this.onSubmit }>

					<div className="row">
						<div className="col-sm-7">
							<label>Text Title</label>
							<input className="form-control" type="text"
								placeholder="Your Awesome Article"
								onChange={ (e) => this.setState({ title: e.target.value.trim() }) } />
						</div>
						<div className="col-sm-5">
							<label>Text Type</label>
							<select className="form-control"
								onChange={ (e) => this.setState({ textVariety: e.target.value.trim() }) } >

								<option value={ TextTypes.Varieties.FICTION }>
									{ TextTypes.Varieties.getName(TextTypes.Varieties.FICTION) }
								</option>
								<option value={ TextTypes.Varieties.NON_FICTION }>
									{ TextTypes.Varieties.getName(TextTypes.Varieties.NON_FICTION) }
								</option>
							</select>
						</div>
					</div>

					<label>URL</label>
					<input className="form-control" type="url"
						placeholder="https://www.example.com/your-awesome-article"
						onChange={ (e) => this.setState({ url: e.target.value.trim() }) } />

					<div className="text-center">
						<LoadingButton className="btn buttonSuccess addButton"
							disabled={ !this.isValid() }
							loading={ this.state.loading }
							text="Add URL"
							onClick={ this.submitTasks } />
					</div>
				</form>
			</div>
		)
	}
};

const URL_REGEX = "[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)";

AddManualURLPick.WrappedComponent.propTypes = StrictPropTypes({
	toggleAssign: PropTypes.func.isRequired,

	// Handlers from @connect
	createBook: PropTypes.func
});


module.exports = AddManualURLPick;



// WEBPACK FOOTER //
// ./modules/components/reading/picks/AddManualURLPick.js